/**
 * ForecastSize
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectQuantityForecastValue } from '../../services/quantityForecasts/selectors';

interface Props {
    size?: ?number;
}

export class ForecastSize extends React.PureComponent<Props> {
    render() {
        const { size } = this.props;
        if (!size && size !== 0) return null;
        return size;
    }
}

const mapStateToProps = createStructuredSelector({
    size: makeSelectQuantityForecastValue('size')
});

export default connect(mapStateToProps)(ForecastSize);
